Object.defineProperty(exports, "__esModule",
{
	value: true
});
const _extends = Object.assign || function(target, ...sources) {
	sources.forEach(source => {
	  for (const key in source) {
		if (Object.prototype.hasOwnProperty.call(source, key)) {
		  target[key] = source[key];
		}
	  }
	});
	return target;
};


const _react = require('react');
const _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj)
{
	return obj && obj.__esModule ? obj :
	{
		default: obj
	};
}
const createIconComponent = function createIconComponent(_ref)
{
	const content = _ref.content,
		height = _ref.height,
		width = _ref.width;
	return function (props)
	{
		return _react2.default.createElement('svg', _extends(
		{}, props,
		{
			style: _extends(
			{}, styles.root, props.style),
			viewBox: '0 0 ' + width + ' ' + height
		}), content);
	};
};
const styles = {
	root:
	{
		display: 'inline-block',
		fill: 'currentcolor',
		height: '1.25em',
		maxWidth: '100%',
		position: 'relative',
		userSelect: 'none',
		textAlignVertical: 'text-bottom'
	}
};
export default createIconComponent;
